const DefaultHeader =  {headers: {"Content-Type": "application/x-www-form-urlencoded"}}

export default DefaultHeader;